import React, { FunctionComponent } from 'react';
import { Menu } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { useUserMgmt } from 'components/UserMgmt/UserMgmt.context';
import { ClassProp } from 'helpers/types';

import styles from './Navigation.styles';

import ExternalNav from './components/ExternalNav';
import InternalNav from './components/InternalNav';

type Styles = ClassProp<typeof styles>;
type Props = {
  classes: Styles;
};

const MainNav: FunctionComponent<Props> = ({ classes }) => {
  const { isInternalUser, isExternalUser } = useUserMgmt();
  return (
    <Menu as="nav" className={classes.menu}>
      {isExternalUser && <ExternalNav />}
      {isInternalUser && <InternalNav />}
    </Menu>
  );
};
export default withStyles(styles)(MainNav);
